var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 797,
    height: 698,
    viewBox: "0 0 797 698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a1749822104269",
    x1: 343,
    y1: 641.5,
    x2: 48,
    y2: 641.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#483202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf8c12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b1749822104269",
    x1: 73,
    y1: 210.203,
    x2: 436,
    y2: 514.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf8c12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M292 610H83l-35 61 295 2s-20.637-17.433-30-29c-14.833-18.324-21-34-21-34",
    style: {
      fillRule: "evenodd",
      fill: "url(#a1749822104269)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171 610 113-192h-72L73 655Zm132-219 133-231-45-90-173 321z",
    style: {
      fillRule: "evenodd",
      fill: "url(#b1749822104269)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "ejn_no_shadow copy",
    d: "m0 698 162-284h193l-36 60H197l-29 48h119l-33 59H136l-38 62 215 1s31.03 39.664 92 54zm175-307h69l155-270 154 270h68L398 0Zm392 23h67l163 284H674L497 501l-1 101s-4.4 60.989-68 73c-74.486 14.067-126.37-27.1-119-98h56s-7.28 50.284 40 46c0 0 30.4.424 32-32s0-177 0-177h61l180 197Z",
    style: {
      fillRule: "evenodd",
      fill: "#dfb44d"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app_logo.4dfda4e76c83a932b0eeec03e7e21fc7.svg";
export { ForwardRef as ReactComponent };